import { useState } from "react";
import _ from "lodash";
import "./ContentSlider2Manual.scss";

const ContentSlider2Manual = ({ templateData, manualEntries, setManualEntries }) => {
  let initialWin = 0;
  let initialDraw = 0;
  let initialLoss = 0;
  let initialQuote = "";
  let initialAuthor = "";
  if (!!manualEntries) {
    initialWin = manualEntries.win;
    initialDraw = manualEntries.draw;
    initialLoss = manualEntries.loss;
    initialQuote = manualEntries.quote;
    initialAuthor = manualEntries.author;
  }

  const [manualWin, setManualWin] = useState(initialWin);
  const [manualDraw, setManualDraw] = useState(initialDraw);
  const [manualLoss, setManualLoss] = useState(initialLoss);
  const [manualQuote, setManualQuote] = useState(initialQuote);
  const [manualAuthor, setManualAuthor] = useState(initialAuthor);

  const onManualWinChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setManualWin(value);
    setManualEntries({
      win: value,
      draw: manualDraw,
      loss: manualLoss,
      quote: manualQuote,
      author: manualAuthor
    });
  };

  const onManualDrawChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setManualDraw(value);
    setManualEntries({
      win: manualWin,
      draw: value,
      loss: manualLoss,
      quote: manualQuote,
      author: manualAuthor
    });
  };

  const onManualLossChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setManualLoss(value);
    setManualEntries({
      win: manualWin,
      draw: manualDraw,
      loss: value,
      quote: manualQuote,
      author: manualAuthor
    });
  };

  const onManualQuoteChange = (e) => {
    const value = e.target.value;
    setManualQuote(value);
    setManualEntries({
      win: manualWin,
      draw: manualDraw,
      loss: manualLoss,
      quote: value,
      author: manualAuthor
    });
  };

  const onManualAuthorChange = (e) => {
    const value = e.target.value;
    setManualAuthor(value);
    setManualEntries({
      win: manualWin,
      draw: manualDraw,
      loss: manualLoss,
      quote: manualQuote,
      author: value
    });
  };

  return (
    <div>
      <div className="content-tab">
        <div className="slider2-manual-form">
          <div className="input-pair">
            <span>WINS</span>
            <input
              type="number"
              className="half-input"
              value={manualWin}
              onChange={onManualWinChange}
            />
          </div>

          <div className="input-pair">
            <span>DRAWS</span>
            <input
              type="number"
              className="half-input"
              value={manualDraw}
              onChange={onManualDrawChange}
            />
          </div>
          <div className="input-pair">
            <span>LOSSES</span>
            <input
              type="number"
              className="half-input"
              value={manualLoss}
              onChange={onManualLossChange}
            />
          </div>

          <div className="input-pair">
            <span>Quote</span>
            <textarea
              className="quote-input"
              value={manualQuote}
              onChange={onManualQuoteChange}
              rows={1}
              style={{ resize: "none" }}
            />
          </div>

          <div className="input-pair">
            <span>Author</span>
            <input
              className="author-input"
              value={manualAuthor}
              onChange={onManualAuthorChange}
            />
          </div>



        </div>
      </div>
    </div>
  );
};

export default ContentSlider2Manual;